/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';

export const ResponsiveGrid = ({
  ':items': items = {},
  ':itemsOrder': itemsOrder = [],
  path = '',
  ...props
}: {
  ':items'?: Record<string, any>;
  ':itemsOrder'?: string[];
  path?: string;
  [key: string]: any;
}) => {
  const order = itemsOrder.length > 0 ? itemsOrder : Object.keys(items || {});

  if (!items || order.length === 0) {
    return null;
  }

  return (
    <div className="storybook-responsive-grid" data-path={path} {...props}>
      {order.map(key => {
        const item = items[key];
        if (!item) return null;
        const itemPath = `${path}/${key}`;
        return (
          <div key={key} className="storybook-responsive-grid-column" data-cq-path={itemPath}>
            <Component
              {...item}
              path={itemPath}
              {...{
                ':items': item[':items'],
                ':itemsOrder': item[':itemsOrder'],
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
